import React, { Component } from "react";
import { shareFacebook, shareTwitter, shareWhatsapp, openNegishut } from "../Services/Sharing"

import "./Header.scss"

class Header extends Component {
  constructor() {
    super()
    this.state = {
      isShareActive: false
    }
    this.activateSharer = this.activateSharer.bind(this);
  }
  activateSharer()  {
    this.setState({
      isShareActive: !this.state.isShareActive
    })
  }
  render() {
    return (
      <header>
        <div id="header">
          <div className="padding">
            <div className="container">
              <div className="publisher">
                <div className={`share${(this.state.isShareActive ? " active " : "")}`}>
                  <div onClick={() => { shareTwitter() }} className="twitter"></div>
                  <div onClick={() => { shareWhatsapp() }} className="whatsapp"></div>
                  <div onClick={() => { shareFacebook() }} className="facebook"></div>
                  <div onClick={() => { this.activateSharer() }} className="sharer"></div>
                  <div onClick={() => { openNegishut() }} className="negishut"></div>
                </div>
              </div>
              <div className="utils">
                <div className="sponser">
                  <a href="https://ynet.co.il/" target="_blank"><div className="ynetlogo"></div></a>
                  <a href="https://www.facebook.com/poweredb/" title="" target="_blank"><div className="pblogo"></div></a>
                  <a href="https://bringbring.com/?utm_source=ynet&utm_medium=item&utm_campaign=world-cup&utm_term=logo" title="" target="_blank"><div className="sponslogo"></div></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="virtualHeader"></div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header/Header.jsx